export default __webpack_public_path__ + "static/media/dobri_s.d1af1d8a.jpg";